import { render } from "./QrPendiente.vue?vue&type=template&id=0a2c0316&scoped=true"
import script from "./QrPendiente.vue?vue&type=script&lang=js"
export * from "./QrPendiente.vue?vue&type=script&lang=js"

import "./QrPendiente.vue?vue&type=style&index=0&id=0a2c0316&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a2c0316"]])

export default __exports__